import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {TagTextComponent} from "./tag-text.component";
import { TagTextDefaultColorPipe } from './tag-text-default-color.pipe';
import { TagTextUnescapePipe } from "./tag-text-unescape.pipe";
import { ReplaceKeywordsPipeModule } from "projects/common/pipes/replace-keywords.module";

@NgModule({
    declarations: [
        TagTextComponent,
        TagTextDefaultColorPipe,
        TagTextUnescapePipe
    ],
    imports: [
        CommonModule, 
        ReplaceKeywordsPipeModule
    ],
    exports: [
        TagTextComponent,
        TagTextDefaultColorPipe,
        TagTextUnescapePipe
    ],
    providers: [
    ],
    bootstrap: [TagTextComponent]
})
export class TagTextModule {}
